import {post} from './RequestUtil'
import vue from '../main'

export const GoodsRequestUtil = {
  queryGoodsList (params, callback) {
    post('/goods/list', params).then((response) => {
      callback && callback(response)
    })
  },
  queryGoodsTrash (params, callback) {
    post('/goods/trash', params).then((response) => {
      callback && callback(response)
    })
  },
  queryGoodsInfo (params, callback) {
    post('/goods/info', params).then((response) => {
      callback && callback(response)
    })
  },
  saveGoodsInfo (params, callback) {
    post('/goods/save', params).then((response) => {
      callback && callback(response)
    })
  },
  pass (params, callback) {
    post('/goods/pass', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  refuse (params, callback) {
    post('/goods/refuse', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  remove (params, callback) {
    post('/goods/remove', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  },
  delete (params, callback) {
    post('/goods/delete', params).then((response) => {
      response.result && vue.$message.success('操作成功')
      callback && callback(response)
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/GoodsRequestUtil.js